<app-dialog [dataSelector]="dataSelector + '-container'">
  <app-dialog-header [dataSelector]="dataSelector + '-header'">Manage "{{ data.file.name }}" links</app-dialog-header>

  <div class="body-300" [dataSelector]="dataSelector + '-description-1'">
    You may review how many times this file has been linked to a
  </div>
  <div class="body-300" [dataSelector]="dataSelector + '-description-2'">
    request and individually manage each of these Linkments here.
  </div>

  <div class="gray-banner" [dataSelector]="dataSelector + '-selected-requests-banner'">
    <div class="banner-left" [dataSelector]="dataSelector + '-banner-left'">
      <span class="h4-500" [dataSelector]="dataSelector + '-selected-requests-label'">Selected requests</span>
      <span class="h1-600 file-count" [dataSelector]="dataSelector + '-request-count'">{{ selectedDocumentsId.length }} {{ selectedDocumentsId.length === 1 ? 'request' : 'requests' }}</span>
    </div>

    <div>
      <button
        [disabled]="selectedDocumentsId.length === 0"
        andButton
        color="ghost-secondary"
        [dataSelector]="dataSelector + '-clear-selection-button'"
        (click)="clearSelection()"
      >
        Clear Selection
      </button>
    </div>
  </div>

  @for (section of (sections$ | async); track section.id; let sectionIndex = $index) {
    @if(section.documents.length !== 0) {
      <div class="section-name" [dataSelector]="dataSelector + '-section-' + sectionIndex">
        <span class="h4-500 color-black" [dataSelector]="dataSelector + '-section-title-' + sectionIndex">
          {{section.name}}
        </span>
      </div>
      
      @for (document of section.documents; track document.data.id; let documentIndex = $index) {        
        <div
          class="document-line-item"
          [class]="{
            'document-line-item-selected': document.selected
          }"
          [dataSelector]="dataSelector + '-document-item-' + sectionIndex + '-' + documentIndex"
          [tooltip]="document.disabledTooltipText"
          [tooltipEnabled]="document.disabled ?? false"
          (click)="selectDocument(document)"
        >
          <mat-checkbox
            [checked]="document.selected"
            [disabled]="document.disabled ?? false"
            class="d-flex"
            [dataSelector]="dataSelector + '-document-checkbox-' + sectionIndex + '-' + documentIndex"
            (click)="selectDocument(document, $event)"
          >
            {{ document.data.name }}
          </mat-checkbox>
        </div>
      }
    }
  }

  <app-dialog-footer [showCancel]="false" [dataSelector]="dataSelector + '-footer'">
    <div class="w-100 d-flex justify-content-between">
      <button
        andButton
        color="default"
        type="button"
        [dataSelector]="dataSelector + '-cancel-button'"
        (click)="onClose()"
      >
        Cancel
      </button>

      <button
        andButton
        color="primary"
        type="button"
        [isLoading]="isLoading"
        [disabled]="!(hasChanges$ | async)"
        [dataSelector]="dataSelector + '-update-links-button'"
        (click)="updateLinks()"
      >
        Update Links
      </button>
    </div>
  </app-dialog-footer>
</app-dialog>

